<template>
    <el-container class="plugin-list">
      <el-header height="312px">
        <img class="banner-img" src="@/assets/img/banner.png" alt="">
      </el-header>
      <el-container>
        <router-view/>
        <el-aside width="140px">
            <div v-bind:class="[{ active: pulgin }]" class="tab" @click='tab(1)'>
                <img src="@/assets/img/all-on.png" alt="" v-if="pulgin">
                <img src="@/assets/img/all.png" alt="" v-else>
                <div>全部应用</div>
            </div>
            <div :class="[{ active: !pulgin }]" class="tab" @click='tab(2)'>
                <img src="@/assets/img/serve-on.png" alt="" v-if="!pulgin">
                <img src="@/assets/img/serve.png" alt="" v-else>
                <div>专业服务</div>
            </div>
        </el-aside>
        <el-main v-loading="loading">
            <el-row  v-if="pulgin">
                <el-col :span="8" v-for="item in pulgin_list" v-bind:key=" item.id" data-id='item.id' v-if="mobile">
                  <div class="plugin-item" style="background: #8cc5ff38;">
                      <div class="plugin-card plugin-icon-bg">
                          <img :src="item.pic_url" alt="" style="background: rgb(64, 158, 255);">
                          <div class="plugin-info">
                            <div class="plugin-name">{{ item.display_name}}</div>
                            <div class="plugin-price">
                                <b>￥{{ item.price }}</b>
                                <span style="font-size: 14px;">{{item.use_name ? item.use_name : ''}}</span>
                            </div>
                          </div>
                      </div>
                      <div>
                        <router-link :to="'/plugin/plugin-info?id=' + item.id"><el-button>查看详情</el-button></router-link>
                        <router-link :to="'/dashboard/plugin-order/edit?id=' + item.id"><el-button class="now">立即购买</el-button></router-link>
                      </div>
                  </div>
                </el-col>
                <el-col :span="24" v-for="item in pulgin_list" v-bind:key=" item.id" data-id='item.id' v-if="!mobile">
                  <div class="plugin-item">
                      <div class="plugin-card">
                          <img :src="item.pic_url" alt="">
                          <div class="plugin-info">
                            <div class="plugin-name">{{ item.display_name}}</div>
                            <div class="plugin-price">
                                <b>￥{{ item.price }}</b>
                                <span style="font-size: 14px;">{{item.use_name ? item.use_name : ''}}</span>
                            </div>
                          </div>
                      </div>
                      <div>
                        <router-link :to="'/plugin/plugin-info?id=' + item.id"><el-button>查看详情</el-button></router-link>
                        <router-link :to="'/dashboard/plugin-order/edit?id=' + item.id"><el-button class="now">立即购买</el-button></router-link>
                      </div>
                  </div>
                </el-col>
            </el-row>
            <el-row v-else style="margin-left: -20px;">
                <el-col :span="12" v-for="item in serve_list" v-bind:key=" item.id" data-id='item.id' v-if="mobile">
                  <div class="serve-item">
                      <div class="serve-card">
                          <img :src="item.pic_url" alt="">
                          <div class="serve-info">
                            <div style="float:left">
                                <div class="serve-name">{{ item.display_name}}</div>
                                <div class="serve-price">
                                    <b>￥{{ item.price }}</b>
                                    <span style="font-size: 14px;">{{item.use_name ? item.use_name : ''}}</span>
                                </div>
                            </div>
                            <el-button class="now" style="float:right;margin-top: 20px;" @click="serve">立即购买</el-button>
                          </div>
                          <div class="serve-explain">{{ item.content1 }}<br/>{{ item.content2 }}</div>
                      </div>
                  </div>
                </el-col>
                <el-col :span="24" v-for="item in serve_list" v-bind:key=" item.id" data-id='item.id' v-if="!mobile">
                  <div class="serve-item">
                      <div class="serve-card">
                          <img :src="item.pic_url" alt="">
                          <div class="serve-info">
                            <div style="float:left">
                                <div class="serve-name">{{ item.display_name}}</div>
                                <div class="serve-price">
                                    <b>￥{{ item.price }}</b>
                                    <span style="font-size: 14px;">{{item.use_name ? item.use_name : ''}}</span>
                                </div>
                            </div>
                            <el-button class="now" style="float:right;margin-top: 20px;" @click="serve">立即购买</el-button>
                          </div>
                          <div class="serve-explain">{{ item.content1 }}<br/>{{ item.content2 }}</div>
                      </div>
                  </div>
                </el-col>
            </el-row>
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            list: [],
            loading: false,
            pulgin: true,
            pagination: null,
            mobile: false,
            pulgin_list: [],
            serve_list: [
                {
                    display_name: '更换站点',
                    price: 800,
                    use_name: '/次',
                    pic_url: require('@/assets/img/change.png'),
                    content1: `域名站点授权，不限制IP，域名只授权1个，但您可以解析多个域名到同一站点，授权的域名必须保证可以访问到站点。`,
                    content2: `禾匠客户首次更换授权域名是免费的，之后收费标准：800/次。`
                },
                {
                    display_name: 'HTTP配置',
                    price: 200,
                    use_name: '/域名',
                    pic_url: require('@/assets/img/https-config.png'),
                    content1: `配置域名SSL证书，在传输层对网络连接进行加密，满足小程序对于https的需要，以及微信对https接口的要求。需要用户自行申请。`,
                    content2: `https证书，申请教程下单后可联系售后群中客服K获取。`
                }
            ]
        }
    },
    created() {
        this.getList()
        if (window.innerWidth > 768) {
            this.mobile = true
        }
    },
    methods: {
        getList() {
            this.loading = true
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'user/plugin/index'
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.list = e.data.data.list
                        this.pulgin_list = e.data.data.list
                        this.pagination = e.data.data.pagination
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        tab(res) {
            if (res === 1) {
                this.pulgin = true
            } else if (res === 2) {
                this.pulgin = false
            }
        },
        serve() {
            this.$message('敬请期待')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .plugin-list{
        width: 1200px;
        margin: 15px auto;
    }

    .el-header{
        padding: 0;
        width: 100%;
        margin-bottom: 15px;
    }

    .banner-img{
        width: 100%;
        height: 100%;
        display: block!important;
    }

    .el-aside{
        height: 244px;
        background-color: #fff;
        border-radius: 14px;
        padding: 44px 0;
    }

    .tab{
        width: 100%;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
    }

    .tab.active{
        color: #2E9FFF;
    }

    .tab img{
        height: 28px;
        width: 28px;
        margin-bottom: 10px;
    }
    .plugin-icon-bg {
        border-radius: 10px;
        font-size: 0;
        display: inline-block;
        margin-right: 16px;
    }
    .tab:first-of-type{
        margin-bottom: 38px;
    }

    .el-main{
        padding: 0;
        margin-left: 15px;
    }

    .plugin-item{
        padding: 24px 30px;
        background-color: #fff;
        border-radius: 14px;
        height: 136px;
        width: 276px;
        margin-bottom: 15px;
    }

    .plugin-card{
        height: 90px;
        width: 100%;
    }

    .plugin-card img{
        margin-left: 30px;
        height: 68px;
        width: 68px;
        float: left;
        margin-right: 30px;
        border-radius: 14px;
    }

    .plugin-name{
        color: #353535;
        padding-top: 5px;
        margin-bottom: 8px;
        font-size: 16px;
    }

    .plugin-price{
        color: #FF4544;
        font-size: 18px;
        margin-bottom: 4px;
    }

    .plugin-explain{
        font-size: 14px;
        color: #BBBBBB;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .serve-item{
        padding: 24px 30px;
        background-color: #fff;
        border-radius: 14px;
        height: 136px;
        margin-left: 20px;
    }

    .serve-card{
        height: 90px;
        width: 100%;
        padding-bottom: 18px;
    }

    .serve-card img{
        height: 68px;
        width: 68px;
        float: left;
        margin-right: 16px;
        border-radius: 14px;
    }

    .serve-info{
        height: 68px;
        width: 100%;
        margin-bottom: 15px;
    }

    .serve-name{
        margin-top: 8px;
        color: #353535;
        margin-bottom: 3px;
        font-size: 16px;
    }

    .serve-price{
        color: #FF4544;
        font-size: 18px;
        margin-bottom: 4px;
    }

    .serve-explain{
        font-size: 14px;
        color: #BBBBBB;
    }

    .el-button{
        padding: 0;
        height: 28px;
        width: 124px;
        border-radius: 14px;
        color: #2E9FFF;
        border-color: #2E9FFF;
    }

    .now{
        margin-left: 25px;
        background-color: #2E9FFF;
        color: #fff;
    }

    @media screen and (max-width:767px){
        .el-main .plugin-list{
            width: 100%;
        }
        .el-header{
            height: 10rem!important;
        }
        .banner-img{
            object-fit: cover;
        }
        .el-aside{
            width: 4rem!important;
        }
        .el-row .plugin-item{
            width: 85%;
            padding: 0.8rem 1rem;
        }
        .plugin-item .el-button{
            width: 44%
        }
        .el-row .serve-item{
            height: 15rem;
            margin-bottom: 1rem
        }
    }
</style>
